export default __webpack_public_path__ + "static/media/kitchen3-afterH-1024w.1c6a050d.png";